
<script>
    import Calculator from './../modules/Calculator'

    export default {
        props: {
            currentTariff: {
                required: false
            },
            tariffPercent: {
                type: Array,
                required: true
            },
        },
        data () {
            return {
                tariff: 3,
                locale: window.locale
            }
        },

        methods: {

            submit(id){
                document.getElementById(id).submit();
            }

        },
        computed: {
            tariffDescription() {
                switch (this.tariff) {
                    case -1:
                        return this.$t('lang.main.tariffs')[0];
                    case 0:
                        return this.$t('lang.main.tariffs')[1];
                    case 1:
                        return this.$t('lang.main.tariffs')[2];
                    case 2:
                        return this.$t('lang.main.tariffs')[3];
                    case 3:
                        return this.$t('lang.main.tariffs')[4];
                    case 4:
                        return this.$t('lang.main.tariffs')[5];
                    case 5:
                        return this.$t('lang.main.tariffs')[6];
                }
            },
            amount1m: function () {
                let calс = new Calculator(this.tariff, 0);
                return calс.getAmount().formatMoney(0, ' ', ' ');
            },
            amount3m: function () {
                let calс = new Calculator(this.tariff, 1);
                return calс.getAmount().formatMoney(0, ' ', ' ');
            },
            amount6m: function () {
                let calс = new Calculator(this.tariff, 2);
                return calс.getAmount().formatMoney(0, ' ', ' ');
            },
            amount12m: function () {
                let calс = new Calculator(this.tariff, 3);
                return calс.getAmount().formatMoney(0, ' ', ' ');
            },
            discount3m: function () {
                let calс = new Calculator(this.tariff, 1);
                return calс.getDiscount().formatMoney(0, ' ', ' ');
            },
            discount6m: function () {
                let calс = new Calculator(this.tariff, 2);
                return calс.getDiscount().formatMoney(0, ' ', ' ');
            },
            discount12m: function () {
                let calс = new Calculator(this.tariff, 3);
                return calс.getDiscount().formatMoney(0, ' ', ' ');
            },
        },
        created() {
            if(this.currentTariff){
                this.tariff = parseInt(this.currentTariff);
            }
        }
    }
</script>
<template>

    <section>
        <div class="row" style="padding-top: 20px" v-if="!currentTariff">

            <h3 class="text-center">{{$t('lang.select_tariff.restr_msg')}}</h3>
            <hr />
            <div class="col-lg-12 text-center tariff-list">

                <a href="#" @click.prevent="tariff = 3;" :class="{active: tariff == 3}">{{$t('lang.main.tariffs')[4]}}</a>
                <a href="#" @click.prevent="tariff = 4;" :class="{active: tariff == 4}">{{$t('lang.main.tariffs')[5]}}</a>
                <a href="#" @click.prevent="tariff = 5;" :class="{active: tariff == 5}">{{$t('lang.main.tariffs')[6]}}</a>

            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="pricing-tables attached">
                    <div class="row">
                        <div class="col-sm-3 col-md-3 col-lg-3">
                            <div class="plan first">
                                <div class="head">
                                    <h2>1 {{$t('lang.main.months_case')[0]}}</h2>
                                </div>
                                <ul class="item-list">
                                    <li><strong>{{$t('lang.select_tariff.tariff_access', [tariffDescription])}}</strong></li>
                                    <li><a :href="'/' + locale + '/tarif'">{{$t('lang.main.btn.more').toLowerCase()}}</a></li>
                                </ul>
                                <div class="price mediafix">
                                    <h3>{{amount1m}} {{$t('lang.main.currency.sign')}}</h3>
                                    <h4>&nbsp;</h4>
                                </div>
                                <form :action="'/' + locale + '/panel'" method="POST" id="amount1m">
                                    <input type="hidden" name="act" value="prolong">
                                    <input type="hidden" name="srok" value="0">
                                    <input type="hidden" name="tarifprolong" :value="tariff">
                                    <a href="#" class="bluebutton" @click.prevent="submit('amount1m')">{{currentTariff ? $t('lang.main.btn.prolong') : $t('lang.main.btn.choose')}}</a>
                                </form>
                            </div>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3">
                            <div class="plan first last recommended">
                                <div class="head">
                                    <h2>3 {{$t('lang.main.months_case')[1]}}</h2>
                                </div>
                                <ul class="item-list">
                                    <li><strong>{{$t('lang.select_tariff.tariff_access', [tariffDescription])}}</strong> {{$t('lang.select_tariff.discount', [discount3m])}}</li>
                                    <li><a :href="'/' + locale + '/tarif'">{{$t('lang.main.btn.more').toLowerCase()}}</a></li>
                                </ul>
                                <div class="price mediafix">
                                    <h3>{{amount3m}} {{$t('lang.main.currency.sign')}}</h3>
                                    <h4>-{{ tariffPercent[1] }}%</h4>
                                </div>
                                <form :action="'/' + locale + '/panel'" method="POST" id="amount3m">
                                    <input type="hidden" name="act" value="prolong">
                                    <input type="hidden" name="srok" value="1">
                                    <input type="hidden" name="tarifprolong" :value="tariff">
                                    <a href="#" class="greenbutton" @click.prevent="submit('amount3m')">{{currentTariff ? $t('lang.main.btn.prolong') : $t('lang.main.btn.choose')}}</a>
                                </form>
                            </div>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3">
                            <div class="plan">
                                <div class="head">
                                    <h2>6 {{$t('lang.main.months_case')[2]}}</h2>
                                </div>
                                <ul class="item-list">
                                    <li><strong>{{$t('lang.select_tariff.tariff_access', [tariffDescription])}}</strong> {{$t('lang.select_tariff.discount', [discount6m])}}</li>
                                    <li><a :href="'/' + locale + '/tarif'">{{$t('lang.main.btn.more').toLowerCase()}}</a></li>
                                </ul>
                                <div class="price mediafix">
                                    <h3>{{amount6m}} {{$t('lang.main.currency.sign')}}</h3>
                                    <h4>-{{ tariffPercent[2] }}%</h4>
                                </div>
                                <form :action="'/' + locale + '/panel'" method="POST" id="amount6m">
                                    <input type="hidden" name="act" value="prolong">
                                    <input type="hidden" name="srok" value="2">
                                    <input type="hidden" name="tarifprolong" :value="tariff">
                                    <a href="#" class="bluebutton" @click.prevent="submit('amount6m')">{{currentTariff ? $t('lang.main.btn.prolong') : $t('lang.main.btn.choose')}}</a>
                                </form>

                            </div>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3">
                            <div class="plan last">
                                <div class="head">
                                    <h2>12 {{$t('lang.main.months_case')[2]}}</h2>
                                </div>
                                <ul class="item-list">
                                    <li><strong>{{$t('lang.select_tariff.tariff_access', [tariffDescription])}}</strong> {{$t('lang.select_tariff.discount', [discount12m])}}</li>
                                    <li><a :href="'/' + locale + '/tarif'">{{$t('lang.main.btn.more').toLowerCase()}}</a></li>
                                </ul>
                                <div class="price mediafix">
                                    <h3>{{amount12m}} {{$t('lang.main.currency.sign')}}</h3>
                                    <h4>-{{ tariffPercent[3] }}%</h4>
                                </div>
                                <form :action="'/' + locale + '/panel'" method="POST" id="amount12m">
                                    <input type="hidden" name="act" value="prolong">
                                    <input type="hidden" name="srok" value="3">
                                    <input type="hidden" name="tarifprolong" :value="tariff">
                                    <a href="#" class="bluebutton" @click.prevent="submit('amount12m')">{{currentTariff ? $t('lang.main.btn.prolong') : $t('lang.main.btn.choose')}}</a>
                                </form>

                            </div>
                        </div>
                    </div>
                    <!-- row-->
                </div>
                <!-- pricing-tables -->
            </div>
        </div>
        <div class="row" style="padding-bottom: 25px">
            <div class="col-centered col-lg-12 text-center">
                <a :href="'/' + locale + '/tarif'" class="graybutton">{{$t('lang.select_tariff.more_compare')}}</a>
            </div>
        </div>
    </section>


</template>

<style scoped>
    section * {-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box}
    .tariff-list a{padding: 0 10px 0 10px;}
    .tariff-list a.active {font-weight: 700;}
    a.greenbutton, a.bluebutton  {text-decoration: none; padding: 0px 10px; font-size: 10px;}
    a.bluebutton {background: #5989d0}
    a.bluebutton:hover {background: #15aac0}
    hr {
        height: 0;
        -webkit-box-sizing: content-box;
        -moz-box-sizing: content-box;
        box-sizing: content-box;
        margin-top: 20px;
        margin-bottom: 20px;
        border: 0;
        border-top: 1px solid #eee;
    }

    /* pricing table */
    .pricing-tables {
        padding: 20px;
    }

    .pricing-tables .btn-link{
        border:none;
        outline:none;
        background:none;
        cursor:pointer;
        padding:0;
        text-decoration:underline;
        font-size:inherit;
        color: #286798;
    }

    .pricing-tables h1 {
        font-size: 48px;
    }
    .pricing-tables .plan.first {
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px !important;
    }
    .pricing-tables .plan.last {
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
    }
    .pricing-tables .plan.recommended {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }
    .pricing-tables .plan.recommended .head {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    .pricing-tables.attached .col-sm-4, .pricing-tables.attached .col-md-4, .pricing-tables.attached .col-sm-3, .pricing-tables.attached .col-md-3 {
        padding-left: 0;
        padding-right: 0;
    }
    .pricing-tables.attached .plan {
        border-radius: 0;
    }
    .pricing-tables.attached .plan .head {
        border-radius: 0;
    }
    .pricing-tables.attached .plan.last {
        border-bottom-right-radius: 4px;
    }
    .pricing-tables.attached .plan.last .head {
        border-top-right-radius: 4px;
    }
    .pricing-tables.attached .plan.first {
        border-bottom-left-radius: 4px;
    }
    .pricing-tables.attached .plan.first .head {
        border-top-left-radius: 4px;
    }
    .plan {
        box-shadow: 0 2px 2px rgba(10, 10, 10, 0.30) !important;
        min-height: 100px;
        background: #fff;
        border-radius: 4px;
        margin: 20px 0;
        padding-bottom: 25px;
        text-align: center;
    }
    .plan .head {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        padding: 12px 16px;
        background: #5989d0;
        color: #fff;
    }
    .plan .head h1, .plan .head h2, .plan .head h3 {
        padding: 0;
        margin: 0;
        font-weight: 100;
    }
    .plan .price {
        border-top: 1px solid #eee;
        margin: 0 auto 20px auto;
        width: 80%;
    }

    .plan .price h3 {
        margin-top: 10px;
        font-size: 42px;
        vertical-align: top;
        line-height: 1;
    }

    .plan .price h4 {
        color: #aaa;
        font-size: 14px;
    }

    .plan .btn {
        padding: 10px 30px;
        text-transform: uppercase;
        font-weight: 500;
    }
    .plan ul {
        list-style-type: none;
        padding: 20px;
        margin: 2px 0 0 0;
    }
    .plan ul li {
        line-height: 22px;
        margin-bottom: 15px;
        font-size: 14px;
        font-weight: 400;
    }
    .plan ul li a {
        text-decoration: underline;
        /*color: #e6e9ed;*/
    }
    .plan ul li:last-child {
        border-bottom: none;
    }
    .plan ul strong {
        font-weight: 700;
    }
    .plan.recommended {
        margin-top: 6px;
        padding-bottom: 45px;
        box-shadow: 0 0 22px rgba(10, 10, 10, 0.42);
        position: relative;
        z-index: 99;
        border-radius: 4px;
    }
    .plan.recommended .head {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        background: #68aa13;
    }
    .head.value{
        background-color: #fdaf17;
        /*margin-bottom: 48px;*/
    }
    .plan.recommended .btn {
        margin-bottom: 10px;
    }
    @media screen and (min-width:770px) and (max-width:990px){
        .plan .mediafix h3 {
            font-size: 55px !important;
            vertical-align: top;
            line-height: 1;
        }
    }


</style>
